import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Cliente único para toda la app.
// NOTA: NO pasamos un `lock` custom: gotrue-js ya elige automáticamente
// Web Locks en el navegador y fallback in-memory cuando no está disponible.
// Inyectar un no-op lock causaba que `signInWithPassword` y `autoRefreshToken`
// corrieran concurrentemente, disparando un SIGNED_OUT espurio (línea 394
// de GoTrueClient.ts) que invalidaba la sesión recién creada contra el server.
// IMPORTANTE: dejamos `autoRefreshToken: false` en el constructor.
// El tick automático de gotrue-js corría en paralelo con `signInWithPassword`
// y disparaba un `SIGNED_OUT` espurio desde GoTrueClient.ts:394 que
// invalidaba la sesión recién creada (comprobado: con autoRefresh=true falla,
// con autoRefresh=false el login entra bien).
// El refresh automático se arranca manualmente desde AuthContext después de
// que la sesión está estable y se detiene en signOut.
export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: false,
    detectSessionInUrl: true,
    storageKey: 'gymnastics-auth',
  }
});

// Para compatibilidad
export const checkSupabaseConnection = async () => ({ connected: true, error: null });
export default supabase;